const DEFAULT_STATE = {
  lastLogin: null,
  token: null
}

export default {
  namespaced: true,
  state: DEFAULT_STATE,
  getters: {
    isContributor(state, getters) {
      const data = getters.data
      if (!data) return false
      return new Date(data.expires) > new Date()
    },
    data(state, getters) {
      if (!state.token) return null
      return JSON.parse(atob(state.token.split('.')[1]))
    },
    email(state, getters) {
      const data = getters.data
      if (!data) return null
      return data.email
    },
    expiration(state, getters) {
      const data = getters.data
      if (!data) return null
      return new Date(data.expires)
    }
  },
  mutations: {
    logout(state) {
      state.token = null
    },
    resetStore(state) {
      state = DEFAULT_STATE
    },
    login(state, token) {
      state.token = token
      state.lastLogin = new Date()
    }
  },
  actions: {
    logout(context) {
      context.commit('logout')
    },
    resetStore(context) {
      context.commit('resetStore')
    },
    login(context, token) {
      context.commit('login', token)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js